export default __webpack_public_path__ + "static/media/april-2018-school-day.9d084ebc.csv";